
export class ValidationHelper {

/**
 * Verify if the string is not null nor empty
 */
    static isValidString(value: string): boolean{
        if(value == null){
            return false;
        }
        if(value.trim() == ""){
            return false;
        }
        return true;
    }

/**
 * Verify if the number is not null and is not NaN
 */
    static isValidNumber(value: number):boolean {
        if(value == null){
            return false;
        }
        if(isNaN(value)){
            return false;
        }
        return true;
    }

/**
 * Verify if the float string is not null, not empty and is not NaN
 */
    static isValidFloat(value: string): boolean{
        if(value == null){
            return false;
        }
        let v = new String(value);
        if(v.trim() == ""){
            return false;
        }
        value = v.replace(",", ".");

        let floatValue = parseFloat(value);

        if(isNaN(floatValue)){
            return false;
        }

        return true;
    }

/**
 * Verify that the value matches the email regex
 */
    static isValidEmail(value :string):boolean{
        if(value == null || value == ""){
            return true;
        }

        //accepts everything but space, then an @, then everything but space, a dot, then everything but space
        const regEx: RegExp = /[^\s]+@[^\s]+\.[^\s]+/;

        return regEx.test(value);
    }

    /**
     *
     */
    static isValidUsername(value: string): boolean {
        if(value == null || value == "" || value.length < 4){
            return false;
        }
        return true;
    }

    /**
     * Verify that the username contains only letters, numbers and underscore
     */
    static isValidUsernameFormat(value: string): boolean {
        if(value == null || value == ""){
            return false;
        }
        // Only allow letters (a-z, A-Z), numbers (0-9) and underscore (_)
        const regEx: RegExp = /^[a-zA-Z0-9_]+$/;
        return regEx.test(value);
    }

/**
 * Verify that the value is not null and matches a quite loose url regex
 * Can also be an empty string
 */
    static isValidUrl(value: string):boolean {
        if(!value){
            return false;
        }
        if(value == ""){
            return true;
        }

        let regEx: RegExp = /.*\.[a-zA-Z]{2,4}/; //VERY loose url validation
        let matchArray: RegExpMatchArray = value.match(regEx);
        if(matchArray){
            return true;
        }
        else {
            return false;
        }
    }

/**
 * Verifiy that the value is not null and is positive
 */
    static isValidPositiveNumber(value: number): boolean {
        if(value == null){
            return false;
        }
        if(value < 0){
            return false;
        }

        return true;
    }

/**
 * Verify that the object is not null and has at least one key
 */
    static isValidObject(object: any): boolean{
        if(object == null){
            return false;
        }
        if(Object.keys(object).length == 0){
            return false;
        }
        return true;
    }

/**
 * Takes an object containing various keys with boolean values and returns the global validity of this object.
 * For an object to be valid, all the values must be true
 * The object can also contains childs also containing boolean values. It will be checked recursively
 */
    static isValid(object: Object): boolean{

        let isValid = true;
        let keys = Object.keys(object);

        keys.forEach(key => {
            if(object[key] instanceof Object){
                let recursiveValidationResult = this.isValid(object[key]);
                if(recursiveValidationResult == false) { isValid = false };
            }
            else if(object[key] == false) {
                isValid = false;
            }
        });

        return isValid;
    }

}
